// ImageKit account: voxi
// Dashboard: https://imagekit.io/dashboard/media-library
export const IMAGEKIT_URL_ENDPOINT = 'https://ik.imagekit.io/voxi'
export const IMAGEKIT_PUBLIC_KEY = 'public_zYIsU3e5Jz8sqNiLIM58VT3fkcQ='

// Asset paths (relative to the urlEndpoint)
export const ASSETS = {
  logoVoxist: 'logo_voxist.svg',
  supportBackground: 'background_support.png'
} as const
